import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import Link from 'components/Link';
import colors from '../../../../../../constants/colors';

const Wrapper = styled.div`
  padding: 25px 30px 0;

  @media screen and (max-width: 992px) {
    padding: 30px calc((100vw - 89.333%) / 2) 0;
  }
`;

const SessionDescription = styled.div``;

const SessionAvatar = styled.div`
  background-color: ${colors.main.dividers};
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 2px;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 15px;
  position: relative;
  height: 60px;
  width: 60px;

  &:before {
    content: '';
    background: ${rgba(colors.main.lightBlue, 0.7)};
    background: linear-gradient(
      35deg,
      ${rgba(colors.main.ruby, 0.5)} 16%,
      ${rgba(colors.main.blue, 0.5)} 64%
    );
    border-radius: 2px;
    opacity: 0;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    position: absolute;
    z-index: 1;
  }
`;

const Session = styled(Link)`
  display: flex;
  align-items: flex-start;
  min-height: 60px;
  width: 100%;
  cursor: pointer;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }

  ${(props) =>
    props.completed
      ? css`
          ${SessionAvatar} {
            &:before {
              opacity: 1;
            }
          }
        `
      : null}
`;

const SessionAbout = styled.div`
  width: 100%;
`;

export { Wrapper, Session, SessionAvatar, SessionDescription, SessionAbout };
